import React from 'react'

const ServerErrorPage = () => (
  <div>
    <h2>Server Error Page.</h2>
  </div>
)

export default ServerErrorPage



// WEBPACK FOOTER //
// ./src/components/error_handling/ServerErrorPage.js